import { render, staticRenderFns } from "./PathwayCreate.vue?vue&type=template&id=3bcecf8c&scoped=true&"
import script from "./PathwayCreate.vue?vue&type=script&lang=js&"
export * from "./PathwayCreate.vue?vue&type=script&lang=js&"
import style0 from "./PathwayCreate.vue?vue&type=style&index=0&id=3bcecf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bcecf8c",
  null
  
)

export default component.exports